import { render, staticRenderFns } from "./ReservationItem.vue?vue&type=template&id=9161811e&scoped=true&"
import script from "./ReservationItem.vue?vue&type=script&lang=js&"
export * from "./ReservationItem.vue?vue&type=script&lang=js&"
import style0 from "./ReservationItem.vue?vue&type=style&index=0&id=9161811e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9161811e",
  null
  
)

export default component.exports